<div class="subBlockContainer product-detail" id="productDetail">
  <child-header [title]="getFullStockProductDetails?.output[0]?.out_stock_code" (closeEvent)="close()"></child-header>
  <div class="subBlockContent">
    <!-- Begin of new UI  -->
    <div *ngIf="loadContent"  class="inner-subBlock-wrapper">
      <!-- <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{getFullStockProductDetails?.output[0]?.out_stock_code}}

          <div *ngIf="out_freight_policy==='Q'" class="basic-icon weight-icon" placement="bottom"
          ngbTooltip="This product may require specialised freight services at an additional charge"></div>
          <div class="produc-secondary-title-wrapper">
            <span class="bold-text">BRAND&nbsp;</span>
            <span>{{getFullStockProductDetails?.output[0]?.out_brand}}</span>
            <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span class="bold-text">STATUS&nbsp;</span>
            <span
              *ngIf="getFullStockProductDetails?.output[0]?.out_condition == 'A' || !getFullStockProductDetails?.output[0]?.out_condition">ACTIVE</span>
            <span *ngIf="getFullStockProductDetails?.output[0]?.out_condition == 'C'">CLEARANCE</span>
            <span *ngIf="getFullStockProductDetails?.output[0]?.out_condition == 'P'">PROMOTION</span>
            <span
              *ngIf="getFullStockProductDetails?.output[0]?.out_condition != 'A' && getFullStockProductDetails?.output[0]?.out_condition != 'C' && getFullStockProductDetails?.output[0]?.out_condition != 'P' && getFullStockProductDetails?.output[0]?.out_condition">OBSOLETE</span>
            <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span class="bold-text">SKU&nbsp;</span>
            <span>{{getFullStockProductDetails?.output[0]?.out_stock_code}}</span>
            <span
              *ngIf="(!getFullStockProductDetails?.output[0]?.out_avail_stock_qty.length || (stringToNumber(getFullStockProductDetails?.output[0]?.out_avail_stock_qty, 'int') * 1) === 0) && getFullStockProductDetails?.output[0]?.out_eta && getFullStockProductDetails?.output[0]?.out_stock_type !='K'">
              <span class="divider-wrapper"
                *ngIf="!getFullStockProductDetails?.output[0]?.out_eta?.includes('1900')">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span class="bold-text"
                *ngIf="!getFullStockProductDetails?.output[0]?.out_eta.includes('1900')">ETA:&nbsp;</span>
              <span
                *ngIf="!getFullStockProductDetails?.output[0]?.out_eta.includes('1900')">{{getFullStockProductDetails?.output[0]?.out_eta }}
                {{getFullStockProductDetails?.output[0]?.out_eta_src}}</span>
            </span>
            <span
              *ngIf="(!getFullStockProductDetails?.output[0]?.out_avail_stock_qty.length || (stringToNumber(getFullStockProductDetails?.output[0]?.out_avail_stock_qty, 'int') * 1) === 0) && getFullStockProductDetails?.output[0]?.out_eta.includes('1900') && getFullStockProductDetails?.output[0]?.out_stock_type !='K'">
              <span class="divider-wrapper"
                *ngIf="getFullStockProductDetails?.output[0]?.out_lead_time">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span class="bold-text" *ngIf="getFullStockProductDetails?.output[0]?.out_lead_time">STANDARD LEAD
                TIME:&nbsp;</span>
              <span style="text-transform:none;"
                *ngIf="getFullStockProductDetails?.output[0]?.out_lead_time">{{(stringToNumber(getFullStockProductDetails?.output[0]?.out_lead_time, 'float') * 1).toString()}}
                Day(s)</span>
            </span>
          </div>
        </div>
      </div>
      <div>
        <!-- <p class="produc-secondary-title-wrapper">
          <span class="bold-text">BRAND&nbsp;</span>
          <span>{{getFullStockProductDetails?.output[0]?.mainProduct.stkBrand}}</span>
          <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="bold-text">STATUS&nbsp;</span>
          <span
            *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus == 'A' || !getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus">ACTIVE</span>
          <span *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus == 'C'">CLEARANCE</span>
          <span *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus == 'P'">PROMOTION</span>
          <span
            *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus != 'A' && getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus != 'C' && getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus != 'P' && getFullStockProductDetails?.output[0]?.mainProduct?.stockStatus">OBSOLETE</span>
          <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span class="bold-text">SKU&nbsp;</span>
          <span>{{getFullStockProductDetails?.output[0]?.mainProduct.stockCode}}</span>
        </p> -->
        <div class="top-divider"></div>
        <div class="row">
          <div class="col-md-7">
            <!-- <div class="margin-wrapper highlight-black-text">DESCRIPTION</div>
            <div class="product-b.product-body-textody-text description-detail">
              <p>{{getFullStockProductDetails?.output[0]?.mainProduct.stkDescription}}</p>
            </div> -->
            <div *ngIf="specification && (!specification?.images || !hasImage)">
              <div *ngIf="hasRewards && currentUserModel.isAU==true;else NZAirpoints" class="top-right">
                <div class="basic-icon qantas-red-lg rewards-icon-lg"></div>                 
              </div>
              <ng-template #NZAirpoints>
                <div *ngIf="hasRewards">
                <div class="basic-icon airpoints-lg-110 airpoints-icon-lg "></div>
              </div>
              </ng-template>
              <img class="carousel-img img-zoom" src="../../images/new_ui/no-image-avaiable.png">
            </div>
            <div [ngClass]="{'active show' :  specification?.images}" *ngIf="specification && specification?.images && hasImage">
              <!-- <ng-container *ngIf="specification.images.length === 1">
                <div *ngFor="let image of specification.images">
                  <img class="carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)">
                </div>
              </ng-container> -->
              <!-- Begin of Carousel -->

              <ngb-carousel *ngIf="specification  && specification?.images?.length > 0" id="carousel-wrapper" #myCarousel="ngbCarousel">
                <ng-template ngbSlide *ngFor="let image of imageBanner; let i = index" [id]="numberToString(i)">
                  <div *ngIf="hasRewards && currentUserModel.isAU==true; else NZAirpoints" class="top-right">                   
                        <div class="basic-icon qantas-red-lg rewards-icon-lg"></div>                                                    
                  </div>
                  <ng-template #NZAirpoints>
                    <div *ngIf="hasRewards">
                    <div class="basic-icon airpoints-lg-110 airpoints-icon-lg "></div>
                  </div>
                  </ng-template>
                  <img class="carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)"
                    (mouseenter)="myCarousel.pause()" (click)="openModel(i)"
                    onError="src='../../images/new_ui/no-image-avaiable.png';">
                </ng-template>
              </ngb-carousel>
              <ul class="carousel-thumbnail" *ngIf="specification.images?.length > 0">
                <li class="carousel-thumbnail__item list-inline-item" *ngFor="let image of imageBanner; let i = index">
                  <div class="selected">
                    <img class="carousel-thumbnail__img img-zoom" [src]="safeImageUrl(image?.out_url)"
                      (click)="myCarousel.select(numberToString(i))" onError="src='../../images/new_ui/no-image-avaiable.png';">
                  </div>
                </li>
              </ul>
              <!-- <p *ngIf="specification?.specs" class="product-note">
                {{specification.specs[0].out_value}}
              </p> -->
            </div>
            <!-- Modal -->
            <div class="modal fade" id="zoomImage" tabindex="-1" role="dialog" aria-labelledby="modalLabel"
              aria-hidden="true" *ngIf="specification && (specification?.images || hasSpecification)">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <!-- <div class="modal-header">
                    <h5 class="modal-title" id="modalLabel">abc</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div> -->
                  <div class="modal-body">
                    <i class="material-icons closebutton-pullfloat-right" data-dismiss="modal"
                      aria-label="Close">close</i>

                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button> -->
                    <div *ngIf="imageBanner[sildeImageIndex]">
                      <img class="carousel-img-pop img-zoom" [src]="safeImageUrl(imageBanner[sildeImageIndex].out_url)">
                    </div>
                    <!-- <div *ngFor="let image of imageBanner; let i = index">
                      <img class="carousel-img-pop img-zoom" [src]="safeImageUrl(image.out_url)">
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <modal-popup></modal-popup>
            <!-- <div class="no-click-small-button"
              *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.currentlyOnPromo && getFullStockProductDetails?.output[0]?.mainProduct?.currentlyOnPromo == 'Y'">
              <span *ngIf="getFullStockProductDetails?.output[0]?.mainProduct?.promoFinish" class="highlight-red-text">PROMOTIONAL
                PRICE UNTIL
                {{getFullStockProductDetails?.output[0]?.mainProduct?.promoFinish}}</span>
              <span *ngIf="!getFullStockProductDetails?.output[0]?.mainProduct?.promoFinish" class="highlight-red-text">PROMOTIONAL
                PRICE</span>
            </div> -->

            <!-- <div class="bundleContainer" *ngIf="hasBundled">
              <div class="top-border-divider"></div>
              <div class="margin-wrapper highlight-red-text">
                BUNDLED COMPONENTS INFO
              </div>
              <div class="bundled">
                <table class="white" style="width:100%">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 10%">
                        SKU
                      </th>
                      <th scope="col" style="width: 10%; text-align: center">
                        QTY
                      </th>
                      <th scope="col" style="width: 60%">
                        DESCRIPTION
                      </th>
                      <th scope="col" style="width: 20%; text-align: right">
                        PRICE(EX GST)
                      </th>
                    </tr>
                  </thead>
                  <tr *ngFor="let product of getFullStockProductDetails?.output[0]?.out_bundled_Product">
                    <td class="underline-link" [routerLink]="['/product/productdetail/'+ product?.stockCode]">
                      {{product?.out_stock_code}}</td>
                    <td style="text-align: center">{{product?.out_avail_stock_qty | number}}</td>
                    <td>{{product?.out_description}}</td>
                    <td style="text-align: right">{{product?.out_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </table>
              </div>
            </div> -->
          </div>
          <div class="col-md-5 checkout-text">
            <div class="title blade-title-font">
              {{getFullStockProductDetails?.output[0]?.out_stock_code}}
              <!-- <div *ngIf="hasQantasRewards" class="basic-icon qantas-red-lg rewards-icon-small" style="float: right;"></div> -->
              <div *ngIf="out_freight_policy==='Q'" class="basic-icon weight-icon" placement="bottom"
              ngbTooltip="This product may require specialised freight services at an additional charge"></div>
            </div>
            <div *ngIf="hasRewards &&  currentUserModel.isAU==true;else NZAirpoints" class="row product-secondary-wrapper" style="padding-left: 8px;">
              <span class="basic-icon qantas-black rewards-icon-small"></span>           
              <P *ngIf="lr_rewards == 1"  class="rewards">{{qantasRewardsMessage}}</P>
              <span *ngIf="lr_rewards > 1" class="rewards">EARN {{lr_rewards}} QANTAS BUSINESS REWARDS POINTS</span>
              <span class="qantas-click-here" (click)="goToRewards()">Are you registered to earn Qantas Points? Click here.</span>
            </div>
            <ng-template #NZAirpoints>
              <div *ngIf="hasRewards">
              <span class="basic-icon airpoints-lg-75 airpoints-icon-small"></span>
              <P *ngIf="lr_rewards == 1"  class="rewards">{{airpointRewardsMessage}}</P>
              <span *ngIf="lr_rewards > 1" class="airpoints">EARN {{lr_rewards}} AIRPOINTS BUSINESS REWARDS</span>
            </div>
            </ng-template>            
            <div *ngIf="isPromotion">
              <img class="float-right" src="../../images/new_ui/promotions-red.png">
              <div class="margin-wrapper highlight-red-text">PROMO PRICE UNTIL
                {{getFullStockProductDetails?.output[0]?.out_promo_end_date}}</div>
            </div>
            <div class="description-detail">
              <p>{{getFullStockProductDetails?.output[0]?.out_description}}</p>
            </div>
            <div>
              <div class="row child-inside-shadow-wrapper">
                <div class="col-6 highlight-black-text">RRP(EX GST)</div>
                <div class="col-6 black-font">{{getFullStockProductDetails?.output[0]?.out_rrp_excl_tax |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</div>
              </div>
              <div class="row child-inside-shadow-wrapper">
                <div class="col-6 highlight-black-text">RESELLER BUY(EX GST)</div>
                <div class="col-6 price-black-text">{{getFullStockProductDetails?.output[0]?.out_current_price |
                              currency:'AUD':'symbol-narrow':'.2-2'}}</div>
              </div>
              <div class="row child-inside-shadow-wrapper">
                <div class="col-6 description-detail" [class.hide-col]="currentUserModel?.hideSOH">SOH
                  {{commonService.showWebMaxQty(getFullStockProductDetails?.output[0]?.out_avail_stock_qty, getFullStockProductDetails?.output[0]?.out_web_max_show)}}
                </div>
                <div class="col-6">
                  <input integerOnly class="text-input-box black-font" type="text" (keypress)="isNumberKey($event)"
                    [value]="inputQty" [(ngModel)]="inputQty" min='0' required>
                  <div class="sort-wrapper">
                    <a><img class="sort-icon" src="../images/new_ui/descending-sort.png"
                        (click)="addByDescendAscend(inputQty, 'descending')"></a>
                    <a><img class="sort-icon" src="../images/new_ui/ascending-sort.png"
                        (click)="addByDescendAscend(inputQty, 'ascending')"></a>
                  </div>
                </div>
              </div>
              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.out_stock_code}}"
                (click)="addToCart(getFullStockProductDetails?.output[0]?.out_stock_code, inputQty)"
                *ngIf="soh && (getFullStockProductDetails?.output[0]?.out_web_sell == 'Y' || getFullStockProductDetails?.output[0]?.out_web_sell == '1')">
                Add to cart
              </div>
              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.out_stock_code}}"
                (click)="addToWatchList(getFullStockProductDetails?.output[0])"
                *ngIf="soh && (getFullStockProductDetails?.output[0]?.out_web_sell == 'Y' || getFullStockProductDetails?.output[0]?.out_web_sell == '1')">
                Add To Watch List
              </div>
<!--              <div class="button button-red button-large ctaButton-wrapper-withBg" *ngIf="showDellPowerQuote"-->
<!--              (click)="GetDellPowerQuotes(getFullStockProductDetails?.output[0]?.out_stock_code)">-->
<!--                Dell Power Quote-->
<!--              </div>-->
              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.out_stock_code}}"
                (click)="sendEnquiry(getFullStockProductDetails?.output[0])"
                *ngIf="getFullStockProductDetails?.output[0]?.out_web_sell == 'E'">
                ENQUIRE
              </div>
              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.out_stock_code}}"
                (click)="goToLink('https://aus.power.targus.com/?s=b6604e6523')"
                *ngIf="currentUserModel.isAU==true&&getFullStockProductDetails?.output[0]?.out_stock_group == '75TA'">
                Product Compatibility Finder
              </div>
              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.out_stock_code}}"
                (click)="goToLink('https://aus.power.targus.com/?s=bc72472152')"
                *ngIf="currentUserModel.isAU==false&&getFullStockProductDetails?.output[0]?.out_stock_group == '75TA'">
                Product Compatibility Finder
              </div>
            </div>
            <div class="vendor-intergration">
              <div id="ccs-logos"></div>
            </div>
          </div>
          <!-- <div class="col-md-5">
            <div class="shadow-wrapper">
              <div class="child-inside-shadow-wrapper">
                <div class="highlight-red-text">SOH</div>
                <div class="black-font">{{soh}}</div>
              </div>

              <div class="child-inside-shadow-wrapper">
                <div class="highlight-red-text" style="padding:0">RESELLER BUY(EX GST)</div>
                <div class="black-font">{{getFullStockProductDetails?.output[0]?.mainProduct?.stkPrice.replace(',', '') |
                  currency:'AUD':'symbol-narrow':'.2-2'}}</div>
              </div>

              <div class="child-inside-shadow-wrapper">
                <div class="highlight-red-text">RRP(EX GST)</div>
                <div class="black-font">{{getFullStockProductDetails?.output[0]?.mainProduct?.recRetail.replace(',', '') |
                  currency:'AUD':'symbol-narrow':'.2-2'}}</div>
              </div>

              <div class="child-inside-shadow-wrapper">
                <div class="highlight-red-text">QUANTITY</div>
                <div>
                  <input integerOnly class="text-input-box black-font" type="text" (keypress)="isNumberKey($event)"
                    [value]="inputQty" [(ngModel)]="inputQty">
                </div>
              </div>

              <div class="button button-red button-large ctaButton-wrapper-withBg"
                id="btn{{getFullStockProductDetails?.output[0]?.mainProduct?.stockCode}}"
                (click)="addToCart(getFullStockProductDetails?.output[0]?.mainProduct?.stockCode, inputQty)" *ngIf="soh">
                Add to cart
              </div>
              <div class="ctaButton-wrapper-withoutBg"
                id="viewBtnDetail{{getFullStockProductDetails?.output[0]?.mainProduct?.stockCode}}" (click)="viewCart()">
                View cart
              </div>

            </div>
          </div> -->
        </div>

        <div class="bundleContainer" *ngIf="hasBundled">
          <div class="top-divider"></div>
          <div class="margin-wrapper highlight-red-text">
            BUNDLED COMPONENTS INFO
          </div>
          <div class="bundled">
            <table class="white table-width">
              <thead>
                <tr class="row">
                  <th class="col-1 width-x10 align-center">
                    QTY
                  </th>
                  <th class="col-2 width-x10">
                    SKU
                  </th>
                  <th class="col-1 width-x10 align-center">
                    SOH
                  </th>
                  <th class="col width-x60">
                    DESCRIPTION
                  </th>
                  <th class="col-2 width-x20 align-right">
                    PRICE(EX GST)
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let product of getFullStockProductDetails?.output[0]?.out_bundled_Product">
                  <tr class="row">
                    <td class="col-1 align-center">{{product?.out_comp_qty | number}}</td>
                    <td class="underline-link col-2" [routerLink]="['bundledproduct/'+ product?.out_stock_code]"
                      *ngIf="product.out_web_sell == 'Y'">
                      <a routerLink='product/{{product?.out_stock_code}}'
                        (click)="checkProductDetail(product?.out_stock_code)" class=" highlight-red-text">
                        {{product?.out_stock_code}}
                      </a>
                    </td>
                    <td class="underline-link col-2" *ngIf="product.out_web_sell == 'N'">
                      <span class="highlight-red-text">
                        {{product?.out_stock_code}}
                      </span>
                    </td>
                    <td class="col-1 align-center">
                      {{commonService.showWebMaxQty(product?.out_avail_stock_qty, product?.out_web_max_show)}}</td>
                    <td class="col">
                      {{product?.out_description}}

                    </td>
                    <td class="col-2 align-right">
                      <img src="../../images/new_ui/promotions-red.png" *ngIf="tDate >= product?.out_promo_start_date.split('-').reverse().join('-') &&
                        product?.out_promo_end_date.split('-').reverse().join('-') >= tDate">
                      {{(stringToNumber(product?.out_current_price, 'float') * stringToNumber(product?.out_comp_qty, 'int') )  | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <ng-container *ngIf="hasSpecification === false">
          <div class="noResult-wrapper">
            <div class="top-divider"></div>

            <div><img src="../images/new_ui/no-found.png"></div>
            <div>No Specification found</div>
            <div>Sorry, the specification has no results.<br>Please try different criteria.</div>
          </div>
        </ng-container>
        <div class="row content" *ngIf="hasSpecification && loadContent">
          <ul class="nav nav-tabs row">
            <li class="col-2">
              <a href="#{{'overview' + getFullStockProductDetails?.output[0]?.out_stock_code}}" id="overview-tab"
                data-toggle="pill" role="tab" aria-controls="overview" aria-selected="true" class="nav-link"
                [class.disabled]="!hasSpecification && !getFullStockProductDetails"
                [ngClass]="{'active' : hasSpecification}">
                OVERVIEW
              </a>
            </li>
            <li class="col-2">
              <a href="#{{'specs' + getFullStockProductDetails?.output[0]?.out_stock_code}}" id="specs-tab"
                data-toggle="pill" role="tab" aria-controls="specs" aria-selected="true" class="nav-link"
                [class.disabled]="!hasSpecification || !specification.specs.length || !hasSpec">
                SPECIFICATIONS
              </a>
            </li>
            <li class="col-2">
              <!-- TODO: Option info should be populated -->
              <!-- <a href="#options" id="options-tab" data-toggle="pill" role="tab" aria-controls="options"
                  aria-selected="true" class="nav-link" [class.disabled]="!optionList?.length"
                  [ngClass]="{'active' : ( hasNotes !== undefined ) && !hasNotes && !imageList?.length && !specificationList?.length && !specificationExtendedList?.length && optionList?.length}">
                  OPTIONS
                </a> -->
              <a href="#{{'options' + getFullStockProductDetails?.output[0]?.out_stock_code}}" id="options-tab"
                data-toggle="pill" role="tab" aria-controls="options" aria-selected="true" class="nav-link"
                [class.disabled]="!specification.options || specification.options.length === 0 || isEnquiryProduct">
                OPTIONS
              </a>
            </li>
            <li class="col-2">
              <a href="#{{'resources' + getFullStockProductDetails?.output[0]?.out_stock_code}}" id="resources-tab"
                data-toggle="pill" role="tab" aria-controls="resources" aria-selected="true" class="nav-link"
                [class.disabled]="(!specification.files && !specification.images && !specification.links) || (!specification.files.length && !specification.images.length && !specification.links.length)">
                RESOURCES
              </a>
            </li>
            <li class="col-2">
              <a href="#{{'links' + getFullStockProductDetails?.output[0]?.out_stock_code}}" id="links-tab"
                data-toggle="pill" role="tab" aria-controls="links" aria-selected="true" class="nav-link"
                [class.disabled]="!specification.links || (specification.links && specification.links?.length < 1)">
                LINKS
              </a>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <!-- Begin of Overview -->
            <div id="{{'overview' + getFullStockProductDetails?.output[0]?.out_stock_code}}" aria-labelledby="overview-tab"
              class='tab-pane fade' [ngClass]="{'active show' : hasSpecification || specification.images}"
              role="tabpanel" *ngIf="specification.images || hasSpecification">
              <!-- <ng-container *ngIf="specification.images.length === 1">
                  <div *ngFor="let image of specification.images">
                    <img class="carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)">
                  </div>
                </ng-container> -->
              <!-- Begin of Carousel -->
              <!-- <ngb-carousel *ngIf="specification.images.length > 1" id="carousel-wrapper" #myCarousel="ngbCarousel">
                  <ng-template ngbSlide *ngFor="let image of imageBanner; let i = index" [id]="i">
                    <img class="carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)"
                      (mouseenter)="myCarousel.pause()">
                  </ng-template>
                </ngb-carousel>
                <ul class="carousel-thumbnail" *ngIf="specification.images.length > 1">
                  <li class="carousel-thumbnail__item list-inline-item" *ngFor="let image of imageBanner; let i = index">
                    <div class="selected">
                      <img class="carousel-thumbnail__img img-zoom" [src]="safeImageUrl(image?.out_url)"
                        (click)="myCarousel.select(i)">
                    </div>
                  </li>
                </ul> -->
              <div *ngIf="specification?.specs"
                class="product-note product-b.product-body-textody-text description-detail">
                <div [ngClass]="{'pre-wrap' :  overviewPreWrap}"
                  innerHTML="{{overviewText && overviewText.length>0 ? overviewText: getFullStockProductDetails?.output[0]?.out_description}}">
                </div>
              </div>
              <div id="ccs-inline-content"></div>
              <div id="ccs-explore-product"></div>
              <div id="ccs-feature-icons"></div>
              <!-- <p *ngIf="specification?.specs" class="product-note">
                    {{getFullStockProductDetails?.output[0]?.mainProduct.stkDescription}}
                </p> -->
            </div>
            <!-- End of Carousel -->
            <!-- End of Overview -->

            <!-- Begin of Specification -->
            <div id="{{'specs' + getFullStockProductDetails?.output[0]?.out_stock_code}}" aria-labelledby="specs-tab"
              class='tab-pane fade' role="tabpanel"
              [ngClass]="{'active show' :  (hasNotes !== undefined) && !hasNotes && !specification.images.length && specification.specs.length}"
              *ngIf="specification.specs.length && hasSpec">
              <table class="product-detail-content-tabs-table table primary-body-text-style"
                *ngIf="specification.specs.length">
                <tbody>
                  <tr *ngFor="let specfication of specification.specs">
                    <td class="width-x30" *ngIf="specfication?.out_value.trim().length !== 0">
                      {{specfication?.out_key}}</td>
                    <td class="spec-info" *ngIf="hasSpecification && specfication?.out_value.trim().length !== 0">
                      {{specfication?.out_value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of Specification -->

            <!-- Start of Options -->
            <div id="{{'options' + getFullStockProductDetails?.output[0]?.out_stock_code}}" aria-labelledby="options-tab"
              class='tab-pane fade' role="tabpanel" *ngIf="specification.options && !isEnquiryProduct"
              [ngClass]="{'active show' :  (hasNotes !== undefined) && !hasNotes && !specification.images.length && specification.specs.length}">
              <div class="page-title-wrapper">
                <div class="row filter-wrapper">
                  <ng-container>
                    <div class="col-md-3">
                      <div class="searchInputGroup">
                        <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" #searchValue placeholder="Filter"
                          onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="filterInput"
                          (ngModelChange)="onChange()">
                      </div>
                    </div>
                    <!-- # brand filter -->
                    <!-- <div class="listpart col-md-2" id="Brand-container">
                      <mat-form-field class="select-wrapper">
                        <mat-select placeholder="Brand" multiple [(ngModel)]="selectedBrands"
                          (change)="filterBrands($event)">
                          <mat-option *ngFor="let brand of fixedBrandList" [value]="brand">
                            {{brand}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div> -->
                    <!-- # type filter -->
                    <div class="listpart" id="type-container">
                      <ng-select class="customDropdwon" [multiple]="true" [items]="filterBy" bindValue="name"
                        bindLabel="name" placeholder="Filter by" [(ngModel)]="selectedFilterBy"
                        (change)="onFilterChange()">

                        <ng-template ng-header-tmp>
                          <div>
                            <button class="btn btn-link" style="margin-left: -5px;" (click)="onSelectAll()">Select
                              All</button>
                            <button class="btn btn-link" (click)="onClearAll()">Clear All</button>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="listpart col-md-1 font-col-highlight" (click)="filterReset()">
                      <span class="resetFilterButton">Reset Filter</span>
                    </div>
                  </ng-container>
                </div>
                <!--No Options-->
                <ng-container>
                  <div class="noResult-wrapper" *ngIf="hasEmptyFilterResult">
                    <div class="top-divider"></div>
                    <div><img src="../images/new_ui/no-found.png"></div>
                    <div>No results found</div>
                    <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>

                  </div>

                </ng-container>
                <!--Has Options-->
                <ng-container *ngIf="!hasEmptyFilterResult && !selectedFilterBy.length">
                  <div class="top-divider"></div>
                  <div class="shared-outer-wrapper">
                    <table matSort (matSortChange)="sortData($event)" class="white table-width">
                      <thead>
                        <tr class="row">
                          <th mat-sort-header="des" class="col-7">DESCRIPTION</th>
                          <th mat-sort-header="soh" class="col-1 padding-left-50">SOH</th>
                          <th mat-sort-header="price" class="col-2 padding-left-100">PRICE</th>
                          <th mat-sort-header="qty" class="col-1">QTY</th>
                          <th class="col-1"></th>
                        </tr>
                      </thead>
                      <tbody *ngIf="this.specification.options !== null && this.specification.options.length !== 0">
                        <ng-container *ngFor="let group of groupedData">
                          <tr class="row product-wrapper group-title-font">
                            <th class="col-7">{{ group.groupName }}</th>
                          </tr>
                          <ng-container *ngFor="let option of group.data">
                            <tr class="row product-wrapper"
                              *ngIf="!((option.out_condition =='T' || option.out_condition =='O') && (option.out_avail_stock_qty == '0.0000' || option.out_avail_stock_qty == ''))">
                              <td class="col-7">
                                <a class="result_desc" routerLink='bundledproduct/{{option?.out_stock_code}}'
                                  (click)="checkProductDetail(option?.out_stock_code)" class=" highlight-red-text">
                                  {{option.out_description}}
                                </a>
                              </td>
                              <td class="col-1 align-right padding-right-35">
                                {{commonService.showWebMaxQty(option.out_avail_stock_qty, option.out_web_max_show)}}
                              </td>
                              <td class="col-2 align-right padding-right-55">
                                {{option.out_current_price| currency:'AUD':'symbol-narrow':'.2-2'}}
                              </td>
                              <td class="col-1">
                                <input integerOnly class="input-wrapper input-wrapper-small align-center" type="text"
                                  value="1" #optionQty>
                              </td>
                              <td class="col-1">
                                <button id="btn{{option.out_stock_code}}" class="button button-red button-small"
                                  (click)="addToCart(option.out_stock_code,optionQty.value)">Add</button>
                              </td>
                              <div class="row product-secondary-wrapper">
                                <div>
                                  <span *ngIf="option.out_brand">
                                    <span class="light-text">BRAND:&nbsp;</span>
                                    <span>{{option.out_brand}}</span>
                                    <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  </span>
                                  <span *ngIf="option.out_condition">
                                    <span class="light-text">STATUS:&nbsp;</span>
                                    <span *ngIf="option.out_condition == 'A' || !option.out_condition">ACTIVE</span>
                                    <span *ngIf="option.out_condition == 'C'">CLEARANCE</span>
                                    <span *ngIf="option.out_condition == 'P'">PROMOTION</span>
                                    <span
                                      *ngIf="option.out_condition != 'A' && option.out_condition != 'C' && option.out_condition != 'P' && option.out_condition">OBSOLETE</span>
                                  </span>
                                  <span *ngIf="option.out_stock_code">
                                    <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                    <span class="light-text">SKU:&nbsp;</span>
                                    <span>{{option.out_stock_code}}</span>
                                  </span>
                                </div>
                              </div>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
                <ng-container *ngIf="!hasEmptyFilterResult && selectedFilterBy.length > 0 && showType">
                  <span class="tableTitle">Type</span>
                  <div class="top-divider"></div>
                  <div class="shared-outer-wrapper">
                    <table class="white width-x100">
                      <thead>
                        <tr class="row">
                          <th class="col-7">DESCRIPTION</th>
                          <th class="col-1">SOH</th>
                          <th class="col-2 padding-left-65">PRICE</th>
                          <th class="col-1">QTY</th>
                          <th class="col-1"></th>
                        </tr>
                      </thead>
                      <tbody *ngIf="types.length > 0">
                        <ng-container *ngFor="let option of types | optionsFilter: selectedBrands : selectedTypes :
                            selectedCategories : selectedSeriese : filterInput : sortingInfoObj : testingString">
                          <tr class="row product-wrapper"
                            *ngIf="!(option.out_condition =='O' && option.out_avail_stock_qty == '0.0000' && option.out_avail_stock_qty == '')">
                            <td class="col-7">
                              <a class="result_desc" routerLink='product/{{option?.out_stock_code}}'
                                (click)="checkProductDetail(option?.out_stock_code)" class=" highlight-red-text">
                                {{option.out_description}}
                              </a>
                            </td>
                            <td class="col-1 align-right padding-right-35">
                              {{stringToNumber(option.out_avail_stock_qty, 'float') | number}}
                            </td>
                            <td class="col-2 align-right padding-right-55">
                              {{option.out_current_price| currency:'AUD':'symbol-narrow':'.2-2'}}
                            </td>
                            <td class="col-1">
                              <input integerOnly
                                class="input-wrapper input-wrapper-small qty-input-wrapper align-center" type="text"
                                value="1" #optionQty>
                            </td>
                            <td class="col-1">
                              <button id="btn{{option.out_stock_code}}" class="button button-red button-small"
                                (click)="addToCart(option.out_stock_code,optionQty.value)">Add</button>
                            </td>
                            <div class="row product-secondary-wrapper">
                              <div>
                                <span *ngIf="option.out_brand">
                                  <span class="light-text">BRAND:&nbsp;</span>
                                  <span>{{option.out_brand}}</span>
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </span>
                                <span *ngIf="option.out_condition">
                                  <span class="light-text">STATUS:&nbsp;</span>
                                  <span *ngIf="option.out_condition == 'A' || !option.out_condition">ACTIVE</span>
                                  <span *ngIf="option.out_condition == 'C'">CLEARANCE</span>
                                  <span *ngIf="option.out_condition == 'P'">PROMOTION</span>
                                  <span
                                    *ngIf="option.out_condition != 'A' && option.out_condition != 'C' && option.out_condition != 'P' && option.out_condition">OBSOLETE</span>
                                </span>
                                <span *ngIf="option.out_stock_code">
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span class="light-text">SKU:&nbsp;</span>
                                  <span>{{option.out_stock_code}}</span>
                                </span>
                              </div>
                            </div>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
                <ng-container *ngIf="!hasEmptyFilterResult && selectedFilterBy.length > 0 && showCategory">
                  <span class="tableTitle">Category</span>
                  <div class="top-divider"></div>
                  <div class="shared-outer-wrapper">
                    <table class="white width-x100">
                      <thead>
                        <tr class="row">
                          <th class="col-7">DESCRIPTION</th>
                          <th class="col-1">SOH</th>
                          <th class="col-2 padding-left-65">PRICE</th>
                          <th class="col-1">QTY</th>
                          <th class="col-1"></th>
                        </tr>
                      </thead>
                      <tbody *ngIf="categories.length > 0">
                        <ng-container *ngFor="let option of categories | optionsFilter: selectedBrands : selectedTypes :
                            selectedCategories : selectedSeriese : filterInput : sortingInfoObj : testingString">
                          <tr class="row product-wrapper"
                            *ngIf="!(option.out_condition =='O' && option.out_avail_stock_qty == '0.0000' && option.out_avail_stock_qty == '')">
                            <td class="col-7">
                              <a class="result_desc" routerLink='product/{{option?.out_stock_code}}'
                                (click)="checkProductDetail(option?.out_stock_code)" class=" highlight-red-text">
                                {{option.out_description}}
                              </a>
                            </td>
                            <td class="col-1 align-right padding-right-35">
                              {{stringToNumber(option.out_avail_stock_qty, 'float') | number}}
                            </td>
                            <td class="col-2 align-right padding-right-55">
                              {{option.out_current_price| currency:'AUD':'symbol-narrow':'.2-2'}}
                            </td>
                            <td class="col-1">
                              <input integerOnly
                                class="input-wrapper input-wrapper-small qty-input-wrapper align-center" type="text"
                                value="1" #optionQty>
                            </td>
                            <td class="col-1">
                              <button id="btn{{option.out_stock_code}}" class="button button-red button-small"
                                (click)="addToCart(option.out_stock_code,optionQty.value)">Add</button>
                            </td>
                            <div class="row product-secondary-wrapper">
                              <div>
                                <span *ngIf="option.out_brand">
                                  <span class="light-text">BRAND:&nbsp;</span>
                                  <span>{{option.out_brand}}</span>
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </span>
                                <span *ngIf="option.out_condition">
                                  <span class="light-text">STATUS:&nbsp;</span>
                                  <span *ngIf="option.out_condition == 'A' || !option.out_condition">ACTIVE</span>
                                  <span *ngIf="option.out_condition == 'C'">CLEARANCE</span>
                                  <span *ngIf="option.out_condition == 'P'">PROMOTION</span>
                                  <span
                                    *ngIf="option.out_condition != 'A' && option.out_condition != 'C' && option.out_condition != 'P' && option.out_condition">OBSOLETE</span>
                                </span>
                                <span *ngIf="option.out_stock_code">
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span class="light-text">SKU:&nbsp;</span>
                                  <span>{{option.out_stock_code}}</span>
                                </span>
                              </div>
                            </div>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
                <ng-container *ngIf="!hasEmptyFilterResult && selectedFilterBy.length > 0 && showSeries">
                  <span class="tableTitle">Series</span>
                  <div class="top-divider"></div>
                  <div class="shared-outer-wrapper">
                    <table class="white width-x100">
                      <thead>
                        <tr class="row">
                          <th class="col-7">DESCRIPTION</th>
                          <th class="col-1">SOH</th>
                          <th class="col-2 padding-left-65">PRICE</th>
                          <th class="col-1">QTY</th>
                          <th class="col-1"></th>
                        </tr>
                      </thead>
                      <tbody *ngIf="series.length > 0">
                        <ng-container *ngFor="let option of series | optionsFilter: selectedBrands : selectedTypes :
                            selectedCategories : selectedSeriese : filterInput : sortingInfoObj : testingString">
                          <tr class="row product-wrapper"
                            *ngIf="!(option.out_condition =='O' && option.out_avail_stock_qty == '0.0000' && option.out_avail_stock_qty == '')">
                            <td class="col-7">
                              <a class="result_desc" routerLink='product/{{option?.out_stock_code}}'
                                (click)="checkProductDetail(option?.out_stock_code)" class=" highlight-red-text">
                                {{option.out_description}}
                              </a>
                            </td>
                            <td class="col-1 align-right padding-right-35">
                              {{stringToNumber(option.out_avail_stock_qty, 'float') | number}}
                            </td>
                            <td class="col-2 align-right padding-right-55">
                              {{option.out_current_price| currency:'AUD':'symbol-narrow':'.2-2'}}
                            </td>
                            <td class="col-1">
                              <input integerOnly
                                class="input-wrapper input-wrapper-small qty-input-wrapper align-center" type="text"
                                value="1" #optionQty>
                            </td>
                            <td class="col-1">
                              <button id="btn{{option.out_stock_code}}" class="button button-red button-small"
                                (click)="addToCart(option.out_stock_code,optionQty.value)">Add</button>
                            </td>
                            <div class="row product-secondary-wrapper">
                              <div>
                                <span *ngIf="option.out_brand">
                                  <span class="light-text">BRAND:&nbsp;</span>
                                  <span>{{option.out_brand}}</span>
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </span>
                                <span *ngIf="option.out_condition">
                                  <span class="light-text">STATUS:&nbsp;</span>
                                  <span *ngIf="option.out_condition == 'A' || !option.out_condition">ACTIVE</span>
                                  <span *ngIf="option.out_condition == 'C'">CLEARANCE</span>
                                  <span *ngIf="option.out_condition == 'P'">PROMOTION</span>
                                  <span
                                    *ngIf="option.out_condition != 'A' && option.out_condition != 'C' && option.out_condition != 'P' && option.out_condition">OBSOLETE</span>
                                </span>
                                <span *ngIf="option.out_stock_code">
                                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                  <span class="light-text">SKU:&nbsp;</span>
                                  <span>{{option.out_stock_code}}</span>
                                </span>
                              </div>
                            </div>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
              </div>
            </div>

            <div id="{{'resources' + getFullStockProductDetails?.output[0]?.out_stock_code}}"
              aria-labelledby="resources-tab" class='tab-pane fade' role="tabpanel"
              [ngClass]="{'active show' : !specification.specs && (specification.images || specification.files)}"
              *ngIf="specification.files || specification.images || specification.links">
              <form [formGroup]="imageForm">
                <div class="margin-wrapper highlight-black-text">ASSETS
                  <div class="productdownload" [class.downloadButton-red]="imageForm.value.downloadImage.length !== 0"
                    (click)="downloadFiles()"></div>
                  <p class="download-text" [class.download-text-red]="imageForm.value.downloadImage.length !== 0"
                    (click)="downloadFiles()">
                    DOWNLOAD SELECTED</p>
                </div>

                <!-- <div class="margin-wrapper highlight-black-text">DOWNLOAD SELECTED</div> -->

                <div class="row">
                  <!-- <ng-container *ngIf="specification.files.length !== 0">
                      <div class="col-2" *ngFor="let file of specification.files">
                        <div class="image-shadow-wrapper">
                          <div class="child-inside-shadow-wrapper-small">
                            <mat-checkbox class="check-box" (change)="onChangeImg(file, $event.checked);onChnageFile(file, $event.checked)">
                            </mat-checkbox>
                            <div class="padding-x10">
                              <img class="brouchures-carousel-img img-zoom" src="/images/new_ui/brochures.png">
                              <div *ngIf="file.out_name?.length == 0"
                                class="product-b.product-body-textody-text brochure-detail">PRODUCT BROCHURE</div>
                              <div class="brochure-carousel-anchor" *ngIf="file.out_name?.length !== 0">
                                <a target="_blank" href="{{file?.out_url}}"
                                  class="product-b.product-body-textody-text">{{file?.out_name}}</a>
                              </div>
                              <div class="brouchures-black-text" title="{{file.description}}">{{file.description}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->
                  <ng-container *ngIf="imageBanner?.length !== 0">
                    <div class="col-2" *ngFor="let image of imageBanner">
                      <div class="image-shadow-wrapper">
                        <!-- <mat-checkbox class="check-box" (change)="onChangeImg(image.out_url, $event.target.checked)">
                                </mat-checkbox> -->
                        <mat-checkbox class="check-box" (change)="onChangeImg(image, $event.checked)">
                        </mat-checkbox>
                        <div class="child-inside-shadow-wrapper-small">
                          <img class="resources-carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)">
                        </div>
                        <!-- <div class="download-button" (click)="downloadFile(image?.out_url.trim(), 'image')">
                                        Download
                                      </div> -->
                      </div>
                    </div>
                  </ng-container>
                </div>
              </form>
              <div class="shared-outer-wrapper" *ngIf="specification.files?.length !== 0 || specification.links?.length !== 0">
                      <table class="white">
                          <thead>
                            <tr class="row">
                              <th class="col-md-10">
                                FILES
                              </th>
                              <th class="col-md-2">
                                TYPE
                              </th>
                            </tr>
                          </thead>
                        <tbody>
                        <tr class="row" *ngFor="let file of specification.files">
                          <td class="col-md-10" *ngIf="file.out_url !== null">
                              <mat-checkbox [class.width-x10]="file.out_name === null && file.out_description === null" (change)="onChangeImg(file, $event.checked)">
                              </mat-checkbox>
                              <div class="text-lowercase display-inline-block margin-l-x10 width-x90">
                              <a target="_blank" *ngIf="file.out_name !== null" href="{{file?.out_url}}"
                              class="file-text">{{file?.out_name}}</a>
                              <a target="_blank" *ngIf="file.out_name === null && file.out_description !== '' " href="{{file?.out_url}}"
                              class="file-text">{{file?.out_description}}</a>
                              <a target="_blank" *ngIf="file.out_name === null && file.out_description === '' " href="{{file?.out_url}}"
                              class="file-text resource-url"> {{ file?.out_url.startsWith('/Download') ? 'https://portal.dickerdata.com.au' + file?.out_url : file?.out_url }}</a>
                            </div>
                          </td>
                          <td class="col-md-2 text-lowercase">
                            {{ file?.out_type }}
                          </td>
                        </tr>
                        <!-- <tr class="row" *ngFor="let link of specification.links">
                          <td class="padding-l-x31 col-md-10">
                            <div class="file-text">
                              <div class="text-lowercase display-inline-block">
                              <a target="_blank" *ngIf="link.out_name?.length !== 0" href="{{link?.out_url}}"
                              >{{link?.out_name}}</a>
                              </div>
                              <span class="file-text" *ngIf="link?.out_description">: {{link?.out_description}}</span>
                            </div>
                          </td>
                          <td class="col-md-2 text-lowercase">
                              {{ link?.out_type }}
                          </td>
                        </tr> -->
                        </tbody>
                      </table>
                </div>
              <!--Image Download-->
              <!-- <div class="divider">
                  <div class="margin-wrapper highlight-black-text">IMAGES</div>
                  <div class="row">
                    <div class="col-3" *ngFor="let image of imageBanner">
                      <div class="image-shadow-wrapper">
                        <div class="child-inside-shadow-wrapper-small">
                          <img class="resources-carousel-img img-zoom" [src]="safeImageUrl(image?.out_url)">
                        </div>
                        <div class="download-button" (click)="downloadFile(image?.out_url.trim(), 'image')">
                          Download
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

              <!--Brouchures Download-->
              <!-- <div class="divider">
                  <div class="margin-wrapper highlight-black-text">BROCHURES</div>
                  <div class="row">
                    <div class="col-3">
                      <div class="image-shadow-wrapper">
                        <div class="child-inside-shadow-wrapper-small">
                          <img class="brouchures-carousel-img img-zoom" src="/images/new_ui/brochures.png">
                        </div>
                        <div class="download-button">
                          View
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

              <!--Brouchures Download-->
              <!-- <div class="divider" *ngIf="specification.links">
                  <div class="margin-wrapper highlight-black-text">WEBSITE</div>
                  <div class="row">
                    <div class="col-3" *ngFor="let link of specification.links">
                      <div class="image-shadow-wrapper">
                        <div class="child-inside-shadow-wrapper-small">
                          <img class="brouchures-carousel-img img-zoom" src="/images/new_ui/websiteView.png">
                        </div>
                        <a (click)="goToLink(link.out_url)">
                          <div class="download-button"> View </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div> -->

            </div>
            <!-- Begin of Links -->
            <div id="{{'links' + getFullStockProductDetails?.output[0]?.out_stock_code}}" aria-labelledby="links-tab"
              class='tab-pane fade' role="tabpanel"
              [ngClass]="{'active show' :  !specification.specs && (specification.links && specification.links.length > 0)}"
              *ngIf="specification.links">
              <table class="white table-width" *ngIf="specification.links.length > 0">
                <thead>
                  <tr class="row">
                    <!-- <th class="col-2">NAME</th> -->
                    <th class="col-4">DESCRIPTION</th>
                    <th class="col-8">LINK</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="row" *ngFor="let link of specification.links">
                    <!-- <td class="col-2">
                      {{link?.out_name}}
                    </td> -->
                    <td class="col-4 text-lowercase">
                      {{link?.out_description}}
                    </td>
                    <td class="col-8">
                      <a style="color:#007bff" target="_blank" href="{{link?.out_url}}"> {{link?.out_url}}</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of Links -->
          </div>
        </div>
      </div>
    </div>

    <!-- End of new UI -->
    <loading-screen *ngIf="!loadContent" [showInnerLoading]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
<!-- <div id="next">
  <router-outlet></router-outlet>
</div> -->

<router-outlet></router-outlet>

<!-- <div id="next">
  <router-outlet></router-outlet>
</div> -->

<!-- <div id="next">
  <router-outlet></router-outlet>
</div> -->
